import {Box, Button, Flex, Image, Text} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import ArrowRight from '@assets/svgs/gym/arrow_right.svg'
import SmileIcon from '@assets/svgs/gym/smile.svg'
import TickIcon from '@assets/svgs/gym/tick.svg'
import PairPart from '@assets/images/gym/pair-part.png'
import MicCard from '../components/MicCard'
import gymRequest from '@apis/gym'
import {
  updatePairDataSpeech,
  upDateIsShowIntroduce,
  upDateTotalPairRecording,
  updateMicAnchor,
  updateRerender,
} from '@redux/gym/gymSlice'
import {useDispatch, useSelector} from 'react-redux'
import ModalClosePage from '../components/ModalClosePage'
import TopTitle from '../components/TopTitle'
import LessonProgress from '../components/LessonProgress'
import AOS from 'aos'
import 'aos/dist/aos.css'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, PATH, SCREEN_REPORT_ERROR} from '@utils/Const'
import {isParamsValid} from '@utils'

const GymPairPage = () => {
  const stateGym = useSelector((state: any) => state.gym)
  const navigate = useNavigate()
  const {lesson_id, lesson_name, type, entry_point, task_id} =
    useLocation().state || {}
  const [pairs, setPair] = useState<any>({})
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const [currentPair, setCurrentPair] = useState<any>(pairs[currentIndex])
  const [isFinish, setIsFinish] = useState<Boolean>(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isParamsValid([lesson_id])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!lesson_id) return
    getPairList()
  }, [])

  useEffect(() => {
    AOS.init()
  }, [])

  useEffect(() => {
    if (!stateGym.isRender) {
      dispatch(updateRerender(true))
    }
  }, [stateGym.isRender])

  useEffect(() => {
    if (currentPair) {
      dispatch(updateMicAnchor(currentPair[0]))
    }
  }, [currentPair])

  useEffect(() => {
    if (pairs?.questions) {
      setCurrentPair(pairs?.questions[currentIndex])
    }
  }, [pairs?.questions, currentIndex])

  function getPairListByGroupCode(pairList: any) {
    let lastOrderId: any = null
    const results: any[] = []
    pairList.forEach((pair: any) => {
      const key = pair.data.group_code
      if (lastOrderId !== key) {
        lastOrderId = key
        results.push([pair])
      } else {
        results[results.length - 1].push(pair)
      }
    })
    return results
  }

  const getPairList = async () => {
    try {
      const pairList = await gymRequest.getGymLessonResult({
        lessonId: lesson_id,
        type: type,
      })
      const pairListByGroupCode = getPairListByGroupCode(
        pairList?.data?.data?.questions,
      )
      setPair({
        questions: pairListByGroupCode,
        ipa_lesson_id: pairList?.data?.data?.ipa_lesson_id,
        turn_play: pairList?.data?.data?.turn_play,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleContinue = () => {
    dispatch(updatePairDataSpeech([]))
    dispatch(upDateTotalPairRecording({}))
    setIsFinish(false)
    if (pairs?.questions?.length > currentIndex + 1) {
      setCurrentIndex(pre => pre + 1)
    } else {
      dispatch(upDateIsShowIntroduce(true))
      navigate('/gym/practice', {
        state: {
          lesson_id,
          lesson_name,
          type: 'LUYEN_TAP',
          entry_point,
          task_id,
        },
      })
    }
  }

  const handleSendDetailsResults = async (
    score: any,
    ipa_lesson_detail_id: any,
    ipa_lesson_id: any,
    turn_play: any,
    type_learn: any,
    is_last_question: any,
  ) => {
    try {
      gymRequest.sendDetailsResults({
        score,
        ipa_lesson_detail_id,
        ipa_lesson_id,
        turn_play,
        type_learn,
        is_last_question,
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Flex
      h={'100vh'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      overflow={'hidden'}>
      <TopTitle lessonName={lesson_name} type={type} />
      {stateGym.isShowIntroduce && (
        <Flex
          data-aos="fade-left"
          flexGrow={1}
          justifyContent={'center'}
          alignItems={'center'}
          gap={'50px'}
          flexDirection={{base: 'column', md: 'row'}}>
          <Image src={PairPart} w={'180px'} h={'180px'} borderRadius={'50%'} />
          <Box textAlign={{base: 'center', md: 'left'}}>
            <Text fontSize={'24px'} fontWeight={600}>
              Phân biệt cặp từ
            </Text>
            <Text my={'16px'} fontWeight={600} maxW={'290px'} fontSize={'16px'}>
              Luyện tập phát âm cặp từ dễ nhầm lẫn để nhanh chóng nhận biết
            </Text>
            <Button
              color={'white'}
              bg={'#1890FF'}
              borderRadius={'12px'}
              display={'flex'}
              gap={'16px'}
              alignItems={'center'}
              mx={{base: 'auto', md: 'unset'}}
              onClick={() => dispatch(upDateIsShowIntroduce(false))}>
              Tiếp tục
              <Image src={ArrowRight} />
            </Button>
          </Box>
        </Flex>
      )}
      {!stateGym.isShowIntroduce && (
        <Flex
          flexDirection={'column'}
          flexGrow={1}
          overflowY={'auto'}
          pb={'24px'}>
          <LessonProgress currentIndex={currentIndex} data={pairs?.questions} />
          <Flex
            flexGrow={1}
            flexDirection={'column'}
            justifyContent={{base: 'start', md: 'center'}}
            gap={{md: '32px'}}>
            {currentPair && (
              <Text
                data-aos="fade-down"
                mt={{base: '16px', md: 0}}
                fontSize={{base: '18px', md: '24px'}}
                fontWeight={700}
                color={'#8C8C8C'}
                align={'center'}>
                Phát âm cặp từ sau đạt trên 75 điểm
              </Text>
            )}

            <Flex
              gap={{base: 0, md: '32px'}}
              px={{base: '16px', md: 0}}
              justifyContent={'center'}
              alignItems={'center'}
              flexDirection={{base: 'column', md: 'row'}}>
              {currentPair &&
                stateGym.isRender &&
                currentPair.map((item: any, index: any) => {
                  return (
                    <Box
                      data-aos={index === 0 ? 'fade-right' : 'fade-left'}
                      key={index}
                      w={{base: '300px', md: '370px'}}
                      onClick={() => dispatch(updateMicAnchor(item))}>
                      <MicCard
                        data={item}
                        setIsFinish={setIsFinish}
                        setIsPlayingVideo={null}
                      />
                    </Box>
                  )
                })}
            </Flex>
          </Flex>
        </Flex>
      )}
      {!stateGym.isShowIntroduce && (
        <Box borderTop={'2px solid #e5e5e5'}>
          <Flex
            maxW={'1000px'}
            py={{base: '16px', lg: '32px'}}
            px={'16px'}
            mx={'auto'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={'16px'}>
            {isFinish ? (
              <Text
                color={'#003D75'}
                fontSize={{base: '16px', md: '20px'}}
                fontWeight={700}
                display={'flex'}
                gap={'16px'}
                alignItems={'center'}>
                {stateGym.isGoodRecording ? (
                  <Image src={TickIcon} />
                ) : (
                  <Image src={SmileIcon} />
                )}
                {stateGym.isGoodRecording ? 'Xuất sắc!' : 'Cố gắng hơn nhé!'}
              </Text>
            ) : (
              <Box></Box>
            )}
            <Button
              isDisabled={!isFinish}
              color={'white'}
              borderRadius={'12px'}
              bg={'#003D75'}
              _hover={{
                bg: '#0066c4',
              }}
              _disabled={{
                bg: '#c9c9c9',
                cursor: 'unset',
              }}
              onClick={() => {
                handleContinue()
                dispatch(updateRerender(false))
                stateGym?.pairDataSpeech.forEach((item: any, index: any) => {
                  let ipaLessonDetailId
                  if (item.text_refs === currentPair[0]?.data?.word) {
                    ipaLessonDetailId = currentPair[0]?.ipa_lesson_detail_id
                  } else {
                    ipaLessonDetailId = currentPair[1]?.ipa_lesson_detail_id
                  }
                  handleSendDetailsResults(
                    Math.round(Number(item?.total_score) * 100),
                    ipaLessonDetailId,
                    lesson_id,
                    pairs?.turn_play,
                    type,
                    pairs?.questions.length == currentIndex + 1,
                  )
                })
              }}>
              Tiếp theo
            </Button>
          </Flex>
        </Box>
      )}
      <FormReportError
        feature={FEATURE_REPORT_ERROR.IPA_COURSE}
        screen={SCREEN_REPORT_ERROR.CAP_TU}
      />
      <ModalClosePage />
    </Flex>
  )
}

export default GymPairPage
